export default "__VITE_ASSET__DTzBI8w6__"